import { parseAsArrayOf, parseAsString } from "nuqs";

export const segmentsSearchQuerySchema = {
    query: parseAsString.withDefault(""),
    tags: parseAsArrayOf(parseAsString).withDefault([] as string[])
};

export const segmentsQueryStateOptions = { history: "replace" as const, clearOnDefault: true };

export const SEGMENTS_SEARCH_DEBOUNCE_MS = 200;
